module.exports = __webpack_public_path__ + "static/order-now-cd-37a96b91d10369944b02bc729573b6c8.png";